module.exports = __webpack_public_path__ + "img/昆明梦想.56d9f5b.png";